/**
 * What a route is painted on.
 *
 * `Surface` in `app.tsx` paints the document itself from this, so a phone's
 * status bar matches the page rather than framing it in a pale band. Three
 * grounds now rather than two:
 *
 *   paper   the invitation — warm oyster, the site's default
 *   forest  the RSVP flow, a full-height pine page
 *   night   the afterparty, darker again, so the neon has something to sit on
 *
 * `/rsvp` and `/afterparty` exactly, not those paths and everything under
 * them: there are no bespoke invitation links any more, so a deeper path is a
 * stale one and gets the ordinary paper "this page has drifted".
 */
export type Surface = "paper" | "forest" | "night";

export function surfaceFor(path: string): Surface {
  if (path === "/afterparty") return "night";
  if (path === "/rsvp") return "forest";
  return "paper";
}

/**
 * Whether the bar has to invert over this route — which is a question about
 * how dark the ground is, not about which dark ground it is, so both of the
 * non-paper surfaces answer yes.
 */
export function isForestRoute(path: string): boolean {
  return surfaceFor(path) !== "paper";
}
